import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-getgems",
  "use": "icon-icon-getgems-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-icon-getgems\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14 2c0 6.627-5.373 12-12 12C2 7.373 7.373 2 14 2zm0 24C7.373 26 2 20.627 2 14c6.627 0 12 5.373 12 12zm12-12c0 6.627-5.373 12-12 12 0-6.627 5.373-12 12-12zm-11-1c5.523 0 10-4.477 10-10-5.523 0-10 4.477-10 10z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol